module.exports = __WEBPACK_EXTERNAL_MODULE_287__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/Sprite","root":["openfl","display","Sprite"],"commonjs":"openfl/display/Sprite","commonjs2":"openfl/display/Sprite"}
// module id = 287
// module chunks = 0